var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDissatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_sentiment_dissatisfied"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_155_561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_155_561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sentiment_dissatisfied",
    d: "M11.625 8.25C11.9375 8.25 12.2031 8.14062 12.4219 7.92188C12.6406 7.70312 12.75 7.4375 12.75 7.125C12.75 6.8125 12.6406 6.54688 12.4219 6.32812C12.2031 6.10938 11.9375 6 11.625 6C11.3125 6 11.0469 6.10938 10.8281 6.32812C10.6094 6.54688 10.5 6.8125 10.5 7.125C10.5 7.4375 10.6094 7.70312 10.8281 7.92188C11.0469 8.14062 11.3125 8.25 11.625 8.25ZM6.375 8.25C6.6875 8.25 6.95312 8.14062 7.17188 7.92188C7.39062 7.70312 7.5 7.4375 7.5 7.125C7.5 6.8125 7.39062 6.54688 7.17188 6.32812C6.95312 6.10938 6.6875 6 6.375 6C6.0625 6 5.79688 6.10938 5.57812 6.32812C5.35938 6.54688 5.25 6.8125 5.25 7.125C5.25 7.4375 5.35938 7.70312 5.57812 7.92188C5.79688 8.14062 6.0625 8.25 6.375 8.25ZM9 10.125C8.15 10.125 7.37812 10.3656 6.68437 10.8469C5.99062 11.3281 5.4875 11.9625 5.175 12.75H6.4125C6.6875 12.2875 7.05312 11.9219 7.50937 11.6531C7.96562 11.3844 8.4625 11.25 9 11.25C9.5375 11.25 10.0344 11.3844 10.4906 11.6531C10.9469 11.9219 11.3125 12.2875 11.5875 12.75H12.825C12.5125 11.9625 12.0094 11.3281 11.3156 10.8469C10.6219 10.3656 9.85 10.125 9 10.125ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69687 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69687 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69687 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69687 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9 15C10.675 15 12.0938 14.4187 13.2563 13.2563C14.4187 12.0938 15 10.675 15 9C15 7.325 14.4187 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0938 4.74375 13.2563C5.90625 14.4187 7.325 15 9 15Z",
    fill: "#888888"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDissatisfied);
export default __webpack_public_path__ + "static/media/dissatisfied.95096967f5ff0ca6cefe99945d37b764.svg";
export { ForwardRef as ReactComponent };